DialogController = App.loadClass 'core::Angular/DialogController'

class exports.DuplicateFileDialogController extends DialogController
    constructor: (@state, @transitions, @scope, @modalInstance, @mups, data, @window, @rootScope) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Duplicate Files Detected'
        @scope.absolute_errors = false
        @scope.files = data.files
        @scope.files_ids = @scope.files.map((file) -> return file.input_files_id)
        @loadInputFilesProcessingStatus()
        @window.inputFileProcessed = @inputFileProcessed

        @scope.replaceDuplicates = () =>
            @scope.disable_replace = true
            # make the request to handle replacing the duplicate files
            @mups.replaceDuplicateFiles(@scope.files).then () =>
                # close the modal when finished
                @modalInstance.close()
                # trigger upload
                @rootScope.$broadcast 'uploads:files_removed'

        @scope.removeDuplicates = () =>
            @mups.queueRemoval @scope.files
            @modalInstance.close()

        @scope.$on '$destroy', () =>
            @rootScope.$broadcast 'uploads:clear_message'

    inputFileProcessed: (data) =>
        for file in @scope.files
            if file.input_files_id is data.input_files_id
                file.finished_processing = true

        @checkProcessedStatus()
        # apply since this happens asynchronously
        @scope.$apply()

    loadInputFilesProcessingStatus: () =>
        @mups.getInputFilesProcessingStatus(@scope.files_ids).then (response) =>
            # match files by id with files from the response
            for file in response.data.data
                # only set finished processing on files that havent already been set by websockets
                for f in @scope.files when f.id is file.input_files_id and not f.finished_processing?
                    f.finished_processing = file.finished_processing
                    # break since file will only match a single f
                    break

            @checkProcessedStatus()

    checkProcessedStatus: () =>
        all_processed = true

        for file in @scope.files when not file.finished_processing? or not file.finished_processing
            all_processed = false
            break

        @scope.disable_replace = if all_processed then false else true
